import * as z from "zod";
import { pendingSettingsChange } from "./pending-settings-change";

/** A pending change plus the signed-in admin's per-change permissions. */
export const pendingSettingsChangeForReview = pendingSettingsChange.extend({
  /** Whether the admin may approve this change (bypass member of its group). */
  canApprove: z.boolean(),
  /** Whether the admin may delete this change (an approver, or its proposer). */
  canDelete: z.boolean(),
});
export type PendingSettingsChangeForReview = z.infer<
  typeof pendingSettingsChangeForReview
>;

export const getPendingSettingsChanges = {
  name: "getPendingSettingsChanges" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ changes: z.array(pendingSettingsChangeForReview) }),
};
